import React from 'react';
import LandingPage from './components/LandingPage';
import DesignerWorkspace from './components/DesignerWorkspace';
import { useDesignContext } from './hooks/useDesignContext';

const hasSharedLinkParams = (): boolean => {
  try {
    const u = new URL(window.location.href);
    return !!(u.searchParams.get('d') || u.searchParams.get('sid'));
  } catch {
    return false;
  }
};

function App() {
  const { setDesignMode } = useDesignContext();
  const [hasSelectedMode, setHasSelectedMode] = React.useState<boolean>(() => {
    if (window.location.pathname.startsWith('/design')) return true;
    if (hasSharedLinkParams()) return true;
    return sessionStorage.getItem('design_tool.mode_selected') === 'true';
  });

  React.useEffect(() => {
    if (!hasSelectedMode && (hasSharedLinkParams() || window.location.pathname.startsWith('/design'))) {
      setHasSelectedMode(true);
    }
  }, [hasSelectedMode]);

  if (!hasSelectedMode) {
    return (
      <LandingPage
        onSelect={(mode) => {
          setDesignMode(mode);
          setHasSelectedMode(true);
        }}
      />
    );
  }

  return <DesignerWorkspace />;
}

export default App;
